import {
  cancelSubscription,
  changeSubscription,
  updateOrganization,
} from "@ckweb/ckfetch/connectables/organization";
import {
  getAvailableSubscriptions,
  createCheckoutSession,
  checkSubscriptionStatus,
  createPaymentMethodSetupSession,
  checkPaymentMethodSetupStatus,
} from "@ckweb/ckfetch/connectables/setup";
import type { CheckoutStatus } from "@/types/subscription";
export type { CheckoutSessionDto } from "@ckweb/ckfetch/connectables/setup";

export function useGetAvailablePlans() {
  return useSafeLocalFetch(
    `getAvailableSubscriptions`,
    getAvailableSubscriptions,
    {
      fallback: [],
      showGlobalLoadingIndicator: true,
      customFetchOpts: {
        allowAnonymous: true,
      },
    },
  );
}

export function useSChangeSubscription() {
  return useSafeLocalFetch(`subscribeToPlan`, changeSubscription, {
    fetchType: "mutate",
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
    defaultErrorMessage:
      "cksetup.subscription.confirmation-step.failedToSubscribeToPlan",
  });
}

export function useCancelSubscription() {
  return useSafeLocalFetch(`cancelSubscription`, cancelSubscription, {
    fetchType: "mutate",
    enableGlobalNotifications: true,
    showGlobalLoadingIndicator: true,
    defaultErrorMessage:
      "cksetup.settings.subscription.cancelSubscriptionFailMessage",
  });
}

export function useCreateCheckoutSession() {
  return useSafeLocalFetch(`createCheckoutSession`, createCheckoutSession, {
    fetchType: "mutate",
    fallback: (res) => {
      if (!res?.clientSecret) {
        devConsole.error("Failed to create checkout session.");
        throw new $ck.utils.UserFriendlyError(
          "cksetup.subscription.payment-step.stripeCheckoutSessionError",
        );
      }
      return res;
    },
  });
}

export function useGetCheckoutSession() {
  return useSafeLocalFetch(`checkSubscriptionStatus`, checkSubscriptionStatus, {
    fallback: (payload) => payload as CheckoutStatus | undefined,
    enableGlobalNotifications: true,
  });
}

export function useCreatePaymentMethodCheckoutSession() {
  return useSafeLocalFetch(
    `createPaymentMethodSetupSession`,
    createPaymentMethodSetupSession,
    {
      fetchType: "mutate",
      enableGlobalNotifications: true,
      showGlobalLoadingIndicator: true,
      fallback: (res) => {
        if (!res?.clientSecret) {
          devConsole.error("Failed to create checkout session.");
          throw new $ck.utils.UserFriendlyError(
            "cksetup.subscription.payment-step.stripeCheckoutSessionError",
          );
        }
        return res;
      },
    },
  );
}

export function useGetPaymentMethodCheckoutSession() {
  return useSafeLocalFetch(
    `checkPaymentMethodSetupStatus`,
    checkPaymentMethodSetupStatus,
    {
      enableGlobalNotifications: true,
    },
  );
}

export function useUpdateOrganization() {
  return useSafeLocalFetch(`updateOrganization`, updateOrganization, {
    fetchType: "mutate",
    enableGlobalNotifications: true,
    showGlobalLoadingIndicator: true,
    defaultErrorMessage:
      "cksetup.settings.organization.updateOrganizationFailMessage",
  });
}
